<template>
  <v-flex xs12>
    <v-card>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 md4>
            <v-text-field v-model="shipmentId"
              :label="$tc('models.shipment')"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field v-model="trackingNumber"
              :label="$tc('attrs.tracking_number')"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4 v-if="!$auth.isCust()">
            <v-text-field v-model="email"
              :label="$t('attrs.email')"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-select v-model="carrierId"
              :items="carriers"
              item-value="id"
              item-text="name"
              :label="$tc('models.carrier')"
              clearable
            ></v-select>
          </v-flex>

          <v-flex xs12 md4>
            <v-select v-model="serviceId"
              :items="filteredServices"
              item-value="id"
              item-text="name"
              :label="$tc('models.service')"
              clearable
            ></v-select>
          </v-flex>

          <v-flex xs12 class="text-sm-right">
            <v-btn color="primary" @click="filter">{{ $t('filter') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import Carrier from '@/client/carrier'
import Service from '@/client/service'

export default {
  name: "OverweightFilterComp",

  data () {
    return {
      carriers: [],
      services: [],
      shipmentId: this.$route.query.shipmentId,
      trackingNumber: this.$route.query.trackingNumber,
      email: this.$route.query.email,
      carrierId: parseInt(this.$route.query.carrierId),
      serviceId: this.$route.query.serviceId
    }
  },

  props: {
  },

  components: {
  },

  computed: {
    filteredServices () {
      if (!this.carrierId) { return [] }

      return this.services.filter(o => parseInt(o.carrier_id) === parseInt(this.carrierId))
    },
  },

  methods: {
    filter () {
      const query = {}
      if (this.shipmentId) { query.shipmentId = this.shipmentId }
      if (this.trackingNumber) { query.trackingNumber = this.trackingNumber }
      if (this.email) { query.email = this.email }
      if (this.carrierId) { query.carrierId = this.carrierId }
      if (this.serviceId) { query.serviceId = this.serviceId }

      this.$router.replace({ query })
    },
  },

  watch: {
  },

  async mounted () {
    this.carriers = await Carrier.all({ per_page: 10000 })
    this.services = await Service.all({ per_page: 10000 })
  }
}
</script>
